import React from "react";
import { useRenderTemplateWithCollections } from "../MacroBindingContext";

export interface MacroHeadingBlockProps {
  text: string;
  level: "1" | "2" | "3" | "4";
}

const MacroHeadingBlock = {
  label: "Heading",
  llmDescription: `A heading block for section titles in email content.
- 'text' (string): The heading text
- 'level' ("1" | "2" | "3" | "4"): Heading level (h1 through h4)
- Supports {{variable}} placeholders for dynamic content
- Inside repeaters, also supports collection bindings like {{program.Name}}, {{room.RoomType}}
- Use h1 for main titles, h2-h4 for subsections`,
  fields: {
    text: {
      type: "text" as const,
      label: "Heading Text",
    },
    level: {
      type: "select" as const,
      label: "Heading Level",
      options: [
        { label: "H1 - Main Title", value: "1" },
        { label: "H2 - Section", value: "2" },
        { label: "H3 - Subsection", value: "3" },
        { label: "H4 - Minor", value: "4" },
      ],
    },
  },
  defaultProps: {
    text: "Program Details",
    level: "2" as const,
  },
  render: (props: MacroHeadingBlockProps) => {
    const render = useRenderTemplateWithCollections();
    const rendered = render(props.text);
    const Tag = `h${props.level}` as keyof JSX.IntrinsicElements;

    return <Tag>{rendered}</Tag>;
  },
};

export default MacroHeadingBlock;
